module.exports = __webpack_public_path__ + "static/media/img-app-interview-pass@2x.95ab462f.png";